import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ProductGrid from "../components/ProductGrid";
import ProductToolbar from "../components/ProductToolbar";
import FilterDrawer, { defaultFilters, productMatchesFilters } from "../components/FilterDrawer";
import useScrollReveal from "../hooks/useScrollReveal";
import { useShop } from "../context/ShopContext";

export default function ProductsPage() {
  const { products, loading } = useShop();
  const [sort, setSort] = useState("new");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [params, setParams] = useSearchParams();
  const search = (params.get("q") || "").trim();
  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    const list = products.filter((p) => {
      const searchMatch = !q || p.name.toLowerCase().includes(q) || p.type.toLowerCase().includes(q) || p.description.toLowerCase().includes(q);
      return searchMatch && productMatchesFilters(p, filters);
    });
    return [...list].sort((a, b) => {
      if (sort === "priceAsc") return Number(a.price) - Number(b.price);
      if (sort === "priceDesc") return Number(b.price) - Number(a.price);
      return Number(b.id) - Number(a.id);
    });
  }, [products, search, filters, sort]);

  useScrollReveal([loading, filtered.length]);

  return (
    <>
      <ProductToolbar count={filtered.length} sort={sort} setSort={setSort} onFilter={() => setDrawerOpen(true)} />
      {search && <div className="px-5 md:px-10"><button onClick={() => setParams({})} className="bg-white border border-stone-200 px-4 py-3 rounded-2xl text-sm">Aramayı temizle: “{search}”</button></div>}
      {loading ? <section className="px-5 py-10">Ürünler yükleniyor...</section> : <ProductGrid products={filtered} />}
      <FilterDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} filters={filters} setFilters={setFilters} resultCount={filtered.length} />
    </>
  );
}
